import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path:'/',
        redirect:'/index'
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('../views/IndexView.vue')
    },
    {      

        // 产品中心
        path: '/product',
        name: 'product',
        component: () => import('../views/ProductView.vue'),
    },
    {   
        
        path: '/product/productId/:productId',
        name: 'productDetails',
        component: () => import("../views/ProductDetailsView.vue")
    },
    {
        path: '/example',
        name: 'example',
        component: () => import('../views/ExampleView.vue')
    },
    {
        path: '/news',
        name: 'news',
        component: () => import('../views/NewsView.vue')
    },
    {
        path: '/news/newsId/:newsId',
        name: 'newsDetails',
        component: () => import('../views/NewsDetailsView.vue')
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/AboutView.vue')
    }, {
        path: '/person1',
        name: 'person1',
        component: () => import('../views/PersonView.vue')
    },{
        path: '/ServiceCentre',
        name: 'ServiceCentre',
        component: () => import('../views/ServiceCentreView.vue')
    },{
        path: '/Brand',
        name: 'Brand',
        component: () => import('../views/BrandView.vue')
    },{
        path: '/GasSafety',
        name: 'GasSafety',
        component: () => import('../views/GasSafetyView.vue')
    },{
        path: '/NewsCenter',
        name: 'NewsCenter',
        component: () => import('../views/NewsCenterView.vue')
    },{
        path: '/Solution',
        name: 'Solution',
        component: () => import('../views/SolutionView.vue')
    },{
        path: '/WfIndexView',
        name: 'WfIndexView',
        component: () => import('../views/WfIndexView.vue')
    },{
        path: '/AboutWfView',
        name: 'AboutWfView',
        component: () => import('../views/AboutWfView.vue')
    },{
        path: '/ZuzhiFrameworkView',
        name: 'ZuzhiFrameworkView',
        component: () => import('../views/ZuzhiFrameworkView.vue')
    },{
        path: '/DevelopmentHistoryView',
        name: 'DevelopmentHistoryView',
        component: () => import('../views/DevelopmentHistoryView.vue')
    },{
        
        // 荣誉资质
        path: '/HonoraryQualificationsView',
        name: 'HonoraryQualificationsView',
        component: () => import('../views/HonoraryQualificationsView.vue')
    },{
        
        // 合作伙伴
        path: '/CustomView',
        name: 'CustomView',
        component: () => import('../views/CustomView.vue')
    },{
        
        // 产品中心分页面
        path: '/product2',
        name: 'product2',
        component: () => import('../views/ProductView2.vue')
    },{
        
        // 产品中心分页面
        path: '/product3',
        name: 'product3',
        component: () => import('../views/ProductView3.vue')
    },{
        
        // 产品中心分页面
        path: '/product4',
        name: 'product4',
        component: () => import('../views/ProductView4.vue')
    },{
        
        // 产品中心分页面
        path: '/product5',
        name: 'product5',
        component: () => import('../views/ProductView5.vue')
    },{
        // 解决方案明细页面
        path: '/Solution/solutionId/:solutionId',
        name: 'Solutiondetail',
        component: () => import('../views/Solutiondetail.vue')
    },{
        // 视频中心页面
        path: '/videoView',
        name: 'videoView',
        component: () => import('../views/videoView.vue')
    },{
        // 在线留言
        path: '/message',
        name: 'message',
        component: () => import('../views/message.vue')
    },{
        // 万丰版图
        path: '/TerritoryView',
        name: 'TerritoryView',
        component: () => import('../views/TerritoryView.vue')
    },{
        // 项目案例
        path: '/projectView',
        name: 'projectView',
        component: () => import('../views/projectView.vue')
    },{
        // 主要业绩
        path: '/PerformanceView',
        name: 'PerformanceView',
        component: () => import('../views/PerformanceView.vue')
    },{
        // 人才招聘
        path: '/TalentrecruitmentView',
        name: 'TalentrecruitmentView',
        component: () => import('../views/TalentrecruitmentView.vue')
    },
    {   //视频中心详情页面
        path: '/video/videoId/:videoId',
        name: 'videoDetailsView',
        component: () => import('../views/videoDetailsView.vue')
    }, {   //国产合资页面
        path: '/JointVentureView',
        name: 'JointVentureView',
        component: () => import('../views/JointVentureView.vue')
    }
    

    
    
]

const router = new VueRouter({
    routes
})

export default router
